import { Component } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { RolesService } from '../services/roles.service';
import { IExcelPerfilAcesso } from '../models/role';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent {
  ERoleAdminString = ERoleAdminString;
  constructor(
    private readonly rolesService: RolesService,
    private readonly sessionService: SessionService

  ) { }

  downloadExcel(): void {
    const perfil: IExcelPerfilAcesso = {
      active: true,
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;


    if (partnerId) {
      perfil.partnerId = partnerId;
    }

    if (companyId) {
      perfil.companyId = companyId;
    }

    if (accountRole) {
      perfil.accountRole = parseInt(accountRole);
    }

    this.rolesService.exportarExcel(perfil);
  }
}
